var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.$wf.isMdUp
    ? _c(
        "w-card",
        { staticClass: "desktop-wrapper" },
        [
          _c(
            "app-chat-wrapper",
            {
              staticClass: "desktop-chat-wrapper",
              on: {
                files: function ($event) {
                  return _vm.onFiles($event)
                },
              },
            },
            [
              _c(
                "w-card-title",
                [
                  _c(
                    "w-link",
                    { staticClass: "mr", attrs: { to: _vm.backUrl } },
                    [_c("w-fa", { attrs: { icon: "arrow-left" } })],
                    1
                  ),
                  _vm._v(" " + _vm._s(_vm.title) + " "),
                  _c("w-spacer"),
                  _c(
                    "w-dropdown",
                    {
                      attrs: { flat: "", right: "", items: _vm.selectItems },
                      on: {
                        click: function ($event) {
                          return _vm.trigger($event)
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "bars" } })],
                    1
                  ),
                ],
                1
              ),
              _vm._t("default"),
            ],
            2
          ),
        ],
        1
      )
    : _c(
        "app-mobile-full-screen-container",
        [
          _c(
            "app-toolbar",
            { attrs: { "drawer-button-disabled": "" } },
            [
              _c(
                "template",
                { slot: "title" },
                [
                  _c(
                    "w-toolbar-item",
                    { staticClass: "ml", attrs: { to: _vm.backUrl } },
                    [_c("w-fa", { attrs: { icon: "arrow-left" } })],
                    1
                  ),
                  _c("w-toolbar-text", { staticClass: "app-title" }, [
                    _vm._v(" " + _vm._s(_vm.title) + " "),
                  ]),
                ],
                1
              ),
              _c(
                "w-toolbar-select",
                {
                  attrs: {
                    "hide-arrow": "",
                    right: "",
                    items: _vm.selectItems,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.trigger($event)
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "ellipsis-v" } })],
                1
              ),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "mobile-wrapper" },
            [
              _c(
                "app-chat-wrapper",
                {
                  staticClass: "mobile-chat-wrapper",
                  on: {
                    files: function ($event) {
                      return _vm.onFiles($event)
                    },
                  },
                },
                [
                  _c(
                    "w-card",
                    { staticClass: "mobile-card" },
                    [_vm._t("default")],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }